import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BackendListModel } from '../models/common/list.model';
import { Currencies, CurrenciesResult } from '../models/currency_master_model/currency';
import { ApiRoutes } from './apiroutes';

@Injectable({
    providedIn: 'root',
})
export class CurrencyService {
    base_url = ApiRoutes.CurrencyMaster;
    currencies: Currencies[] = [];

    constructor(private http: HttpClient) { }

    getAllCurrencies(
        page_size = 500,
        page = 1,
        search = '',
        order = ''
    ) {
        let url = `${this.base_url}currency/`;
        let urlObj = new URL(url);
        urlObj.searchParams.append('page_size', String(page_size));
        urlObj.searchParams.append('page', String(page));
        if (search != '') urlObj.searchParams.append('search', String(search));
        if (order != '') urlObj.searchParams.append('o', String(order));

        this.http.get<CurrenciesResult>(String(urlObj)).subscribe((res) => {
            this.currencies = res.results;
            return res;
        });
    }
}
